import Image from '@base/Image';
import { emptyObject } from '@constants/empty';
import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import AquillaButton from 'aquilla/core/molecules/Button';
import RightChevron from 'aquilla/icons/actions/RightChevron';
import { numberFormatter } from '../constants';
import AutoScroller from './AutoScroller';

const Container = styled.div`
  height: 96px;
  padding: ${Spacings.SPACING_6B};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: ${Spacings.SPACING_1} solid var(--color-divider);
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    border: none;
    padding: ${Spacings.SPACING_0B};
  }
`;

const LearnerImageWrapper = styled.div`
  position: relative;
  height: ${Spacings.SPACING_12B};
  width: ${Spacings.SPACING_12B};
`;

const TextInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6};
`;

const RightArrow = styled(RightChevron)`
  ${mediaQuery.aboveMobile} {
    display: none;
  }
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_4B};
  align-items: center;
  ${mediaQuery.uptoMobile} {
    gap: ${Spacings.SPACING_6};
  }
`;

const SliderContainer = styled.div``;

const ViewWinnersCta = styled(AquillaButton)`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const ViewWinnersCard = ({ scrollTOHallOfFame, socialProofing }) => {
  const isMobile = useIsMobile();
  const {
    extraBlockInfo: { laptopWinnersCount = emptyObject } = emptyObject,
    iconUrl,
    socialProofingData
  } = socialProofing;

  const scrollToView =
    ({ onlyMobile }) =>
    () => {
      if ((onlyMobile && isMobile) || !onlyMobile) scrollTOHallOfFame();
    };
  return (
    <Container onClick={scrollToView({ onlyMobile: true })}>
      <LeftWrapper>
        <LearnerImageWrapper>
          <Image src={iconUrl} alt="Laptop Won" layout="fill" />
        </LearnerImageWrapper>
        <TextInfoWrapper>
          <Typography variant="h6">
            {numberFormatter(laptopWinnersCount)} learners have won laptops
          </Typography>
          {socialProofingData && (
            <SliderContainer>
              <AutoScroller socialProofingData={socialProofingData} />
            </SliderContainer>
          )}
        </TextInfoWrapper>
      </LeftWrapper>
      <ViewWinnersCta
        variant="secondary"
        size="large"
        onClick={scrollToView({ onlyMobile: false })}
      >
        View winners
      </ViewWinnersCta>
      <RightArrow />
    </Container>
  );
};

export default ViewWinnersCard;
